import Analytics from '@/utils/analytics';
import React from 'react';
import {
  Platform,
  StyleProp,
  StyleSheet,
  Text,
  TextStyle,
  TouchableOpacity,
} from 'react-native';
import { TrackingProperties } from '@/utils/analytics/base-reporter';
import { TYPOGRAPHY } from '@/styles';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  children: string;
  onPress?: () => void;
  style?: StyleProp<TextStyle>;
  trackingProperties: TrackingProperties;
}

export const RestaurantAccountListItemText: React.FC<Props> = ({
  children,
  style,
  trackingProperties,
  onPress,
}) => {
  const theme = useTheme();
  return (
    <TouchableOpacity
      disabled={!onPress}
      onPress={() => {
        Analytics.track(
          'restaurant_account.list_item_text.press',
          trackingProperties,
        );
        onPress?.();
      }}
    >
      <Text
        numberOfLines={1}
        // Disable selection on Android since there are issues with selectable
        // text in a FlatList and it's not typical UX anyway
        selectable={Platform.OS !== 'android'}
        selectionColor={theme.colors.alertPositive}
        style={[TYPOGRAPHY.listTitle, styles.base, style]}
      >
        {children}
      </Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  base: {
    // Set flex-start so the copy tooltip is centered with the text
    alignSelf: 'flex-start',
  },
});
